import React, { useEffect, useState } from "react";
import { getSettings } from "../lib/api";
import { Cloud } from "lucide-react";

// Branded letterhead for exported PDFs. Falls back to the app brand when no client branding is set.
export const BrandLetterhead = ({ title, subtitle }) => {
  const [brand, setBrand] = useState(null);
  useEffect(() => { getSettings().then(setBrand).catch(() => setBrand({})); }, []);
  const company = brand?.company_name;
  const logo = brand?.logo;
  return (
    <div className="flex items-center gap-3 pb-5 border-b border-zinc-800" data-testid="brand-letterhead">
      {logo ? (
        <img src={logo} alt="logo" className="h-10 w-10 rounded-md object-contain bg-white/5" data-testid="brand-logo" />
      ) : (
        <div className="h-10 w-10 rounded-md bg-blue-600 flex items-center justify-center"><Cloud className="h-6 w-6 text-white" /></div>
      )}
      <div>
        <div className="font-heading font-extrabold text-white tracking-tight text-lg" data-testid="brand-title">
          {company ? `${company} — ${title}` : `UC Engineer Pro — ${title}`}
        </div>
        <div className="text-[11px] text-zinc-500 font-mono">
          {brand?.tagline ? `${brand.tagline} · ` : ""}{subtitle} · generated {new Date().toLocaleString()}
        </div>
      </div>
    </div>
  );
};
